// client/src/hooks/useListaEspera.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const errMsg = (err, fallback) => err.response?.data?.error || err.response?.data?.message || fallback;

// ---------------------------------------------------------------------
// Config
// ---------------------------------------------------------------------

export const useListaEsperaConfig = () => useQuery({
    queryKey: ['listaEspera', 'config'],
    queryFn: () => apiClient.get('/lista-espera/config').then((r) => r.data.data),
});

export const useSalvarListaEsperaConfig = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (payload) => apiClient.put('/lista-espera/config', payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['listaEspera', 'config'] });
            setAlert('Configuração de lista de espera salva com sucesso.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao salvar configuração de lista de espera.'), 'danger'),
    });
};

// ---------------------------------------------------------------------
// Entradas
// ---------------------------------------------------------------------

export const useListaEsperaEntradas = (params = {}) => useQuery({
    queryKey: ['listaEspera', 'entradas', params],
    queryFn: () => apiClient.get('/lista-espera', { params }).then((r) => r.data),
    placeholderData: (prev) => prev,
});

export const useCriarEntradaListaEspera = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (payload) => apiClient.post('/lista-espera', payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['listaEspera', 'entradas'] });
            setAlert('Cliente adicionado à lista de espera.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao adicionar à lista de espera.'), 'danger'),
    });
};

export const useCancelarEntradaListaEspera = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (id) => apiClient.post(`/lista-espera/${id}/cancelar`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['listaEspera', 'entradas'] });
            setAlert('Entrada cancelada.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao cancelar entrada.'), 'danger'),
    });
};

export const useConverterEntradaListaEspera = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: ({ id, agendamentoId }) => apiClient.post(`/lista-espera/${id}/converter`, { agendamentoId }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['listaEspera', 'entradas'] });
            setAlert('Entrada marcada como convertida.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao converter entrada.'), 'danger'),
    });
};
